import React from "react";
import Navbar from "../../../components/navbar/Navbar";
import Footer from "../../../components/footer/Footer";
import FacultySection from "./faculty-section/FacultySection";
import FacultyProfileSection from "./faculty-profile-section/FacultyProfileSection";
import SocialMediaPanel from "../../../components/common/social-media/SocialMediaPanel";

const FacultyIndex = () =>{
    return(
    <>
    
 
        <FacultySection />
        <FacultyProfileSection />
    
    </>
    );
};

export default FacultyIndex;